/**
 * ship-country-notice.js
 * Unhides snippets/ship-country-notice.liquid for visitors whose GeoIP country is
 * not a destination of this store.
 *
 * Liquid cannot do this: a visitor outside every market falls back to the primary
 * market, so localization.country reports DE for them. Shopify's
 * /browsing_context_suggestions.json returns the detected country itself. The
 * answer is cached for the session, so it costs one request per visit.
 *
 * Fails closed: no answer, no notice.
 */
(function () {
  'use strict';

  var CACHE_KEY = 'ucon-geo-country';
  var detected = null;

  function countryName(code, fallback) {
    try {
      var names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
      return names.of(code) || fallback || code;
    } catch (e) {
      return fallback || code;
    }
  }

  function apply(root) {
    if (!detected) return;
    (root || document).querySelectorAll('[data-ship-notice]:not([data-ship-notice-done])').forEach(function (notice) {
      // Marked first: the writes below are DOM mutations, and the drawer observer
      // would otherwise call back into this for the same node.
      notice.setAttribute('data-ship-notice-done', '');
      var list = (notice.getAttribute('data-ship-countries') || '').split(',');
      if (!list[0] || list.indexOf(detected.code) !== -1) return;

      var us = notice.querySelector('[data-ship-notice-us]');
      var text = notice.querySelector('[data-ship-notice-text]');
      if (detected.code === 'US' && us) {
        us.hidden = false;
        if (text) text.hidden = true;
      } else if (text) {
        text.textContent = (text.getAttribute('data-template') || '')
          .replace('[country]', countryName(detected.code, detected.name));
      }
      notice.hidden = false;
    });
  }

  function load() {
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && cached.code) return Promise.resolve(cached);
    } catch (e) {
      /* Storage blocked: just ask again. */
    }
    return fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country;
        if (!c || !c.handle) return null;
        var result = { code: String(c.handle).toUpperCase(), name: c.name || '' };
        try {
          window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
        } catch (e) {
          /* Not cached, still used. */
        }
        return result;
      });
  }

  // No check for a notice on the page: an empty cart drawer gains one on its first
  // re-render, after this has run. The lookup is cached, so it is once per session.
  if (!window.fetch) return;

  load()
    .then(function (result) {
      detected = result;
      apply(document);
    })
    .catch(function () { /* Fail closed. */ });

  // The cart drawer is re-rendered wholesale by the Cart Section Rendering API, which
  // replaces the notice without a page load.
  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () { apply(drawer); })
      .observe(drawer, { childList: true, subtree: true });
  }

  window.uconShipCountryNotice = apply;
})();
